import { createSlice } from '@reduxjs/toolkit'
import PageService from "../PageService";

const initialState = {
    data: {
        totalItems: 0,
        items: []
    },
    requestParams: PageService.createFindPageVersionsDefaultParams()
}

export const pageVersionListSlice = createSlice({
    name: 'pageVersionList',
    initialState,
    reducers: {
        offsetChanged: (state, action) => {
            state.requestParams.offset = 0
        },
        filterByStateChanged: (state, action) => {
            state.requestParams.filterByState = action.payload
            state.requestParams.offset = 0
        },
        isActiveChanged: (state, action) => {
            state.requestParams.isActive = action.payload
            state.requestParams.offset = 0
        },
        sortByChanged: (state, action) => {
            state.requestParams.sortBy = action.payload
            state.requestParams.offset = 0
        },
        sortDirectionChanged: (state, action) => {
            state.requestParams.sortDirection = action.payload
            state.requestParams.offset = 0
        },
        dataChanged: (state, action) => {
            state.data = action.payload
            state.requestParams.offset = state.data.items.length
        }
    }
})

export const {
    offsetChanged,
    filterByStateChanged,
    isActiveChanged,
    sortByChanged,
    sortDirectionChanged,
    dataChanged
} = pageVersionListSlice.actions

export default pageVersionListSlice.reducer